// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3cUmM","buttons":"RemoveExpirationActionButtons_buttons__3CwJq"};